import { render, staticRenderFns } from "./LearningGoals.vue?vue&type=template&id=71fc584c&"
import script from "./LearningGoals.vue?vue&type=script&lang=js&"
export * from "./LearningGoals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports